const firebaseConfig = {
  apiKey: "AIzaSyDzHuMkpoxM8Y6-YRxPmrbhVFsRNmKKi4c",
  authDomain: "meditation-yoga-e9ac9.firebaseapp.com",
  projectId: "meditation-yoga-e9ac9",
  storageBucket: "meditation-yoga-e9ac9.appspot.com",
  messagingSenderId: "120420911840",
  appId: "1:120420911840:web:19a59f5c802ae271ea5e85"
};

export default firebaseConfig;